<template>
  <div class="form-row d-info d-frame">
    <h3>Subskrypcja Xbox Game Pass Core <span v-if="time">na {{ time }} msc</span></h3>
    <p>Przedstawiamy Xbox Game Pass Core z konsolowym trybem wieloosobowym online, katalogiem ponad 25 wysokiej jakości
      gier, ofertami dla użytkowników i nie tylko.</p>

    <p><a href="" @click.prevent="showMore = true" v-if="!showMore">więcej informacji</a></p>
    <div v-if="showMore">
      <h3>Wszystkie korzyści, jakie niesie ze sobą Xbox Live Gold</h3>
      <p>Zapewnia korzyści płynące z konsolowego trybu wieloosobowego online z Xbox Live Gold, a także dostęp do
        biblioteki ponad 25 wysokiej jakości gier konsolowych, w które można grać na konsoli Xbox Series X|S lub Xbox
        One — wszystko to w tej samej świetnej cenie, co Xbox Live Gold *.</p>

      <h3>Gry wysokiej jakości</h3>
      <p>Ciesz się katalogiem ponad 25 wysokiej jakości gier na konsole, takich jak Grounded, Among Us, Hellblade:
        Senua's Sacrifice, nie tylko. Zanurz się w wybranych tytułach z kultowych serii, takich jak Halo, Forza,
        Psychonauts, Fallouti innych, które od dawna były na Twojej liście do wypróbowania.</p>

      <h3>Oferty i zniżki dla członków</h3>
      <p>Korzystaj z ofert dla członków i rabatów do 50% na wybrane gry dzięki promocjom Game Pass.</p>

      <h3>Przejdź na Ultimate</h3>
      <p>Uaktualnij do Game Pass Ultimate, aby mieć dostęp do najnowszych premierowych tytułów. Możesz również grać z
        przyjaciółmi w setki gier wysokiej jakości na konsolach, komputerach lub w w chmurze *.</p>

      <h3>INSTRUKCJA WYKORZYSTANIA OTRZYMANEGO KODU/KLUCZA:</h3>
      <p>Zrealizuj na <a href="https://microsoft.com/redeem" target="_blank">microsoft.com/redeem</a>.</p>

      <h3>WARUNKI UŻYTKOWANIA:</h3>
      <p>* Funkcje różnią się zależnie od konsoli. Zawartość katalogu gier zmienia się z czasem i różni zależnie od
        regionu i urządzenia. Katalog Game Pass Core zastępuje funkcję Games with Gold. Możesz anulować subskrypcję w
        dowolnym momencie. Xbox Cloud Gaming (Beta): usługa wymaga obsługiwanej gry i może wymagać obsługiwanego
        kontrolera Bluetooth® (każdy z tych produktów jest dostępny do nabycia osobno). Wybrane regiony i urządzenia.
        Obowiązują limity dotyczące przesyłania strumieniowego; dostępność serwerów i czas oczekiwania mogą być inne od
        przedstawionych. Wymagane jest połączenie z Internetem, obowiązują opłaty ustalone przez usługodawców
        internetowych.
        <a href="https://xbox.com/gamepass" target="_blank">xbox.com/gamepass</a></p>

      <p><a href="" @click.prevent="showMore = false">zwiń</a></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopupCodesInfoXboxLive',
  props: ['time'],
  data () {
    return {
      showMore: false
    }
  }
}
</script>
